import { useUser } from '@/entities/user/model/user.store';

import { MENA_COUNTRY_CODES } from '@/shared/constants';

export const useIsWheelAdAvailable = () => {
  const user = useUser();

  const isAllowedToSeeAdForCountry =
    !!user?.country && !MENA_COUNTRY_CODES.includes(user?.country);

  return isAllowedToSeeAdForCountry;
};
